import * as types from '../mutation-types'
import {unionState} from '../union-state'

const state = {
	unit_sizes: [],
};
const actions = {

	fetchAll({ commit }) {
		return window.axios.get('UnitSizes'
		).then(response => {
			commit(types.STORE_UNIT_SIZES, response.data);
			return response.data;
		});
	},

	create({ commit }, { unit_size }) {
		return window.axios.post(`UnitSizes`, {
            name: unit_size.name,
            notes: unit_size.notes,
		}).then(response => {
			// commit(types.STORE_ONE_UNIT_SIZE, response.data)
            commit('', '')
			return response.data;
		});
	},

	update({ commit }, { unit_size }) {
		return window.axios.put(`UnitSizes/${unit_size.id}`, {
			id: unit_size.id,
			name: unit_size.name,
            notes: unit_size.notes,
		}).then( response => {
			// commit(types.STORE_ONE_UNIT_SIZE, response.data);
            commit('', '')
			return response.data;
		});
	},

	delete({ commit }, { id }) {
		return window.axios.delete(`UnitSizes/${id}`).then(() => {
			// commit(types.DELETE_UNIT_SIZE, id)
            commit('', '')
		});
	},
};

const mutations = {
    
	[types.STORE_UNIT_SIZES](state, unit_sizes) {
		state.unit_sizes = unit_sizes;
	},

	[types.STORE_ONE_UNIT_SIZE](state, unit_size) {
		state.unit_sizes = unionState(state.unit_sizes, [unit_size]);
	},

	[types.DELETE_UNIT_SIZE](state, unit_size) {
		state.unit_sizes = unionState(state.unit_sizes, [unit_size]);
	},
};

const getters = {
    getById: state => id => state.unit_sizes.find(t => t.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

